import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { detailEntries, formatDate, formatLabel, formatValue } from './adminConfig';

const EmailBadge = ({ sent }) => {
  if (sent === undefined) return null;
  return sent
    ? <span className="bg-gray-100 px-2 py-0.5 text-xs font-bold text-gray-700" data-testid="admin-email-status-sent">Email sent</span>
    : <span className="bg-yellow-300 px-2 py-0.5 text-xs font-bold text-gray-900" data-testid="admin-email-status-failed">Email failed</span>;
};

const DetailValue = ({ field, value }) => {
  if (field === 'email' && value) return <a href={`mailto:${value}`} className="underline">{value}</a>;
  if (field === 'phone' && value) return <a href={`tel:${value}`} className="underline">{value}</a>;
  return formatValue(value);
};

export const AdminRecordRow = ({ tab, record }) => {
  const [open, setOpen] = useState(false);

  return (
    <li data-testid={`admin-record-${record.id}`}>
      <button type="button" onClick={() => setOpen(!open)} aria-expanded={open} className="flex w-full items-start gap-4 px-5 py-4 text-left transition-colors hover:bg-gray-50" data-testid="admin-record-toggle">
        <div className="min-w-0 flex-1">
          <div className="mb-1 flex flex-wrap items-center gap-2">
            <span className="font-bold" data-testid="admin-record-title">{tab.title(record)}</span>
            <EmailBadge sent={record.emailSent} />
          </div>
          <p className="truncate text-sm text-gray-600">{tab.subtitle(record)}</p>
        </div>
        <span className="hidden shrink-0 text-sm text-gray-500 sm:block" data-testid="admin-record-date">{formatDate(record[tab.dateKey])}</span>
        <ChevronDown className={`h-5 w-5 shrink-0 transition-transform ${open ? 'rotate-180' : ''}`} aria-hidden="true" />
      </button>
      {open && (
        <dl className="grid grid-cols-1 gap-x-8 gap-y-4 border-t border-gray-200 bg-gray-50 px-5 py-6 sm:grid-cols-2" data-testid="admin-record-details">
          {detailEntries(record).map(([field, value]) => (
            <div key={field} className={field === 'issueDescription' || field === 'experienceSummary' ? 'sm:col-span-2' : ''}>
              <dt className="text-xs font-bold uppercase tracking-widest text-gray-500">{formatLabel(field)}</dt>
              <dd className="mt-1 whitespace-pre-wrap break-words text-sm text-gray-900"><DetailValue field={field} value={field === tab.dateKey ? formatDate(value) : value} /></dd>
            </div>
          ))}
        </dl>
      )}
    </li>
  );
};
